module.exports = __webpack_public_path__ + "img/02.781e5b6.png";